import { useEffect, useState } from "react";

// Single source of truth for the "mobile vs. desktop" breakpoint - replaces several independent
// copies of `window.innerWidth >= 1024` + a manual resize listener that used to live in
// PageMaster.tsx, ChatHistory.tsx and the dead components/layout/{Layout,Sidebar}.tsx (Task #77,
// 2026-07-16). 1024px matches what those call sites already agreed on.
export const MOBILE_BREAKPOINT = 1024;

const computeIsMobile = (breakpoint: number) =>
    typeof window !== "undefined" && window.innerWidth < breakpoint;

export const useIsMobile = (breakpoint: number = MOBILE_BREAKPOINT): boolean => {
    const [isMobile, setIsMobile] = useState(() => computeIsMobile(breakpoint));

    useEffect(() => {
        const handleResize = () => setIsMobile(computeIsMobile(breakpoint));
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
};
